import { Form, Input } from "antd";
import { NormalInputStyle } from "@src/components/Common/Styles";
import React from "react";
import RateLimitFields from "@src/components/LLMModels/LLMForms/RateLimitFields";


const ChatCompletionModelForm = (_props: any) => {
    return (
        <>
            <Form.Item
                label="API Key"
                name={["extra_data", "api_key"]}
                rules={[{ required: true, message: "Please enter the API key" }]}
            >
                <Input.Password placeholder="Enter API key" visibilityToggle={false} style={NormalInputStyle} />
            </Form.Item>

            <Form.Item
                label="Base URL"
                name={["extra_data", "base_url"]}
                tooltip="Optional. Leave blank to use the provider's default endpoint."
                rules={[{ type: 'url', message: "Please enter a valid URL" }]}
            >
                <Input placeholder="Optional — provider default if left blank" style={NormalInputStyle} />
            </Form.Item>

            <RateLimitFields />
        </>
    );
}

export default ChatCompletionModelForm;
